import { defineComponent as _defineComponent } from 'vue'
import { PropType } from 'vue';
import { ToastProps } from 'ah-common-lib/src/toast';
import { useToast } from './Toast';


export default /*#__PURE__*/_defineComponent({
  __name: 'ToastHolder',
  props: {
  toastData: {
    type: Array as PropType<ToastProps[]>,
    required: true,
  },
  toastComponent: {
    type: Object as PropType<Vue>,
    required: true,
  },
},
  setup(__props) {

const toast = useToast();



function closeToast(id: string) {
  toast.remove(id);
}

return { __sfc: true,toast, closeToast }
}

})